import script from "./Requisites.vue?vue&type=script&setup=true&lang=ts"
export * from "./Requisites.vue?vue&type=script&setup=true&lang=ts"

import "./Requisites.vue?vue&type=style&index=0&id=0fa635dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa635dc"]])

export default __exports__